import React from 'react'
import styled from 'styled-components'
import { mediaQ } from '../theme/mixins'

const LoaderContaner = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1100;
  background-color: rgba(0, 0, 0, 0.35);

  .loader {
    .lds-ring {
      display: inline-block;
      position: relative;
      width: 80px;
      height: 80px;
      position: absolute;

      top: calc(50% - 3vw);
      left: calc(50% - 3vw);
      width: 6vw;
      height: 6vw;
    }
    .lds-ring div {
      box-sizing: border-box;
      display: block;
      position: absolute;
      top: calc(50% - 3vw);
      left: calc(50% - 3vw);
      width: 6vw;
      height: 6vw;
      margin: 8px;
      border: 8px solid #a1ff68;
      border-radius: 50%;
      animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
      border-color: #a1ff68 transparent transparent transparent;

      @media only screen and (max-width: 600px) {
        top: calc(50% - 10vw);
        left: calc(50% - 10vw);
        width: 20vw;
        height: 20vw;
      }
    }
    .lds-ring div:nth-child(1) {
      animation-delay: -0.45s;
    }
    .lds-ring div:nth-child(2) {
      animation-delay: -0.3s;
    }
    .lds-ring div:nth-child(3) {
      animation-delay: -0.15s;
    }
    @keyframes lds-ring {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }

  @keyframes rot {
    100% {
      transform: rotate(360deg);
    }
  }
`

const Loader = () => {
  return (
    <LoaderContaner>
      <div className="loader">
        <div className="lds-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </LoaderContaner>
  )
}

export default Loader
